import { api } from './api'

export const incluirServicoFinanceiro = (
  nome: string,
  descricao: string,
  ativo: boolean = true,
  token: string
) => {
  const url = "/ServicoFinanceiro";
  const servicoFinanceiro = {
    nome,
    descricao,
    ativo,
  };

  return api.post(
    url,
    { servicoFinanceiro },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const editarServicoFinanceiro = (
  id: number,
  nome: string,
  descricao: string,
  ativo: boolean,
  token: string
) => {
  const url = "/ServicoFinanceiro";

  const servicoFinanceiro = { id, nome, descricao, ativo };

  return api.put(
    url,
    { servicoFinanceiro },
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const obterTotalDeCotas = (IdServicoFinanceiro: number) => {
  const url = `/Gerencial/TotalCotas?&IdServicoFinanceiro=${encodeURIComponent(
    IdServicoFinanceiro
  )}`;

  return api.get(url);
};

export const obterRankingDePosicoes = (NumeroPagina: number, TamanhoPagina: number, token: string) => {
    const url = `/Cliente/Ranking/Posicao?NumeroPagina=${NumeroPagina}&TamanhoPagina=${TamanhoPagina}`;

    return api.get(url, {
        headers: {
            Authorization: "Bearer " + token,
        },
    });
};

export const obterTodosClientes = (token: string) => {
  const url = "/Cliente/Todos"

  return api.get(url, {
    headers: {
      Authorization: "Bearer " + token,
    },
  }
  )
}
